import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../__legacy__/models/error.model';
import { MainApiService } from '../../../../__legacy__/services/api.service';
import { IApiServiceImageUpload } from '../../../../__legacy__/services/api.service.imageUpload';

export interface ICheckAttachmentNameUniquenessRequest {
  workspaceId: string;
  attachmentId: string;
  name: string;
  parentId?: string;
}

export interface ICheckAttachmentNameUniquenessService {
  checkAttachmentNameUniqueness(request: ICheckAttachmentNameUniquenessRequest): Promise<boolean>;
}

export namespace ICheckAttachmentNameUniquenessService {
  export const $: interfaces.ServiceIdentifier<ICheckAttachmentNameUniquenessService> = Symbol('CHECK_ATTACHMENT_NAME_UNIQUENESS_SERVICE');
}

@injectable()
export class CheckAttachmentNameUniquenessService implements ICheckAttachmentNameUniquenessService {
  constructor(@inject(IApiServiceImageUpload.$) private readonly apiServiceImageUpload: MainApiService) {}

  async checkAttachmentNameUniqueness(request: ICheckAttachmentNameUniquenessRequest): Promise<boolean> {
    const result = await this.apiServiceImageUpload.getAsync<boolean>('/Attachments/CheckAttachmentNameUniqueness', { params: request });

    if (result instanceof ACDLError) {
      throw result;
    }

    return result;
  }
}
